'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'screwdriver-wrench';
var width = 576;
var height = 512;
var aliases = ["tools"];
var unicode = 'f7d9';
var svgPathData = 'M70.7-6.7c5.4-5.4 13.8-6.2 20.2-2L209.7 70.5c8.9 5.9 14.2 15.9 14.2 26.6l0 60.9 83.2 83.2c34.5-19.7 79.3-14.8 108.8 14.7L542.1 382.1c18.7 18.7 18.7 49.1 0 67.9l-60.1 60.1c-18.7 18.7-49.1 18.7-67.9 0L288 384c-29.5-29.5-34.4-74.2-14.7-108.8l-83.2-83.2-60.9 0c-10.7 0-20.7-5.3-26.6-14.2L23.3 58.9c-4.2-6.3-3.4-14.8 2-20.2L70.7-6.7zM176 144l0-38.3-89.9-59.9-8.3 8.3 59.9 89.9 38.3 0zM448 476.1L508.1 416 382.1 289.9c-16.6-16.6-43.5-16.6-60.1 0s-16.6 43.5 0 60.1L448 476.1zM39.4 391.4l141.1-141.1 33.9 33.9-141.1 141.1 0 0c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L221.8 367.4c5.6 15.3 13.9 29.8 25.1 42.8l-94.3 94.3c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1zM272 97.1c0-17.2-5.5-33.7-15.5-47.3 30.5-30.8 72.7-49.9 119.5-49.9 27.1 0 52.8 6.4 75.5 17.9 6.9 3.5 11.7 10 12.9 17.6s-1.3 15.3-6.7 20.8l-73.7 73.7 0 30.1 30.1 0 73.7-73.7c5.4-5.4 13.2-7.9 20.8-6.7s14.2 6 17.6 12.9c11.4 22.7 17.9 48.4 17.9 75.5 0 41.3-14.9 79.2-39.7 108.4l-34.1-34.1c16.1-20.4 25.8-46.3 25.8-74.3 0-6.9-.6-13.7-1.7-20.3L441 201c-2.6 2.6-5.8 4.6-9.2 5.7-28.4-20-62.6-28.1-95.7-24.3l0-62.4c0-6.4 2.5-12.5 7-17l53.3-53.3c-6.6-1.1-13.4-1.7-20.3-1.7-44.5 0-83.3 24.2-104 60.1l0-11z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faScrewdriverWrench = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;